import { render } from "./FontSpecimenElement.vue?vue&type=template&id=38716046"
import script from "./FontSpecimenElement.vue?vue&type=script&lang=js"
export * from "./FontSpecimenElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/elements/FontSpecimenElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38716046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38716046', __exports__)) {
    api.reload('38716046', __exports__)
  }
  
  module.hot.accept("./FontSpecimenElement.vue?vue&type=template&id=38716046", () => {
    api.rerender('38716046', render)
  })

}


export default __exports__